import React, { useRef } from 'react'

import { ArrowsOutwardSvg, BuildingSvg } from '@svg/react'

import useOutsideClick from '@adUtilities/hooks/use-outside-click'

import PanelTransitionWrapper from './PanelTransitionWrapper'
import ProjectSwitchPanel from './ProjectSwitchPanel'
import useProjectSwitch from './useProjectSwitch'

interface ProjectSwitchToggleProps {
  className?: string
  showOverlayOnProcessing?: boolean
  overlayClassName?: string
}

function ProjectSwitchToggle({
  className = '',
  showOverlayOnProcessing,
  overlayClassName = '',
}: ProjectSwitchToggleProps) {
  const {
    enable,
    isPanelVisible,
    isProcessing,
    projectGroup,
    handleTogglePanel,
    handleProjectSwitch,
  } = useProjectSwitch()

  const containerRef = useRef<HTMLDivElement>(null)
  const isOverlayVisible = showOverlayOnProcessing && isProcessing

  useOutsideClick({
    ref: containerRef,
    isOpen: !isOverlayVisible && isPanelVisible,
    onOutsideClick: handleTogglePanel,
  })

  if (!enable || !projectGroup.length) {
    return null
  }

  return (
    <>
      {isOverlayVisible && (
        <div className={`fixed inset-0 ${overlayClassName}`} />
      )}
      <div
        ref={containerRef}
        className={`${isProcessing ? 'pointer-events-none opacity-90' : ''} ${className}`}
      >
        <div className="relative h-full w-full">
          <button
            className="relative z-[99999] flex h-full w-full items-center rounded-full bg-white px-[5px] py-[8px] shadow"
            type="button"
            title="Switch Project"
            onClick={handleTogglePanel}
          >
            <BuildingSvg className="h-6 w-6" />
            <ArrowsOutwardSvg className="h-[18px] w-[18px]" />
          </button>
          <PanelTransitionWrapper enter={!!isPanelVisible}>
            <ProjectSwitchPanel
              className="absolute z-1 overflow-hidden"
              isProcessing={isProcessing}
              projects={projectGroup}
              handleProjectSelect={handleProjectSwitch}
            />
          </PanelTransitionWrapper>
        </div>
      </div>
    </>
  )
}

export default ProjectSwitchToggle
